import React, { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { PageLoading } from '@components';

import Header from './header';
import Sider from './sider';
import NavContent from './navcontent';
import { StyledLayout as Layout, StyledContent as Content } from './styles';

const DefaultLayout = () => (
  <Layout>
    <Sider />
    <Layout>
      <Header />
      <NavContent />
      <Content>
        <Suspense fallback={<PageLoading />}>
          <Outlet />
        </Suspense>
      </Content>
    </Layout>
  </Layout>
);

export default DefaultLayout;
